<script>
  import { onMount } from 'svelte';
  import { tenantLogado } from '../../Classes/Stores.js';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';

  let tenant;
  $: tenant = $tenantLogado;

  let historico = [];
  let carregando = false;
  let mensagem = '';
  let codigoIndicacao = '';
  let ultimoTenantId = null;
  let diasAmigo = 15;
  let diasIndicador = 10;

  $: if (tenant && tenant.id && tenant.id !== ultimoTenantId) {
    ultimoTenantId = tenant.id;
    codigoIndicacao = tenant.slug ? `INDICA-${tenant.slug.toUpperCase()}` : `INDICA-${tenant.id}`;
    buscarConfig();
    buscarHistorico();
  }

  async function buscarConfig() {
    try {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_obter_config_indicacao, { body: {} });
      if (res && res.sucesso) {
        diasAmigo = res.dias_indicado || diasAmigo;
        diasIndicador = res.dias_indicador || diasIndicador;
      }
    } catch (e) {
      console.error('Erro ao buscar configuração de indicação:', e);
    }
  }

  async function buscarHistorico() {
    if (!tenant || !tenant.id) return;

    carregando = true;
    try {
      const conexao = new Conexoes();
      const res = await conexao.conecta(Constantes.api_listar_indicacoes, {
        body: { id_tenant: tenant.id }
      });

      if (res && res.sucesso) {
        historico = res.indicacoes || [];
      } else {
        historico = [];
      }
    } catch (e) {
      console.error('Erro ao buscar histórico de indicação:', e);
      historico = [];
    } finally {
      carregando = false;
    }
  }

  function copiarCodigo() {
    if (!codigoIndicacao) return;
    navigator.clipboard.writeText(codigoIndicacao);
    mensagem = 'Código copiado!';
    setTimeout(() => mensagem = '', 2800);
  }

  function formatarData(dataString) {
    if (!dataString) return '-';
    const d = new Date(dataString);
    return d.toLocaleDateString('pt-BR') + ' às ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  }
</script>

<div class="card-painel">
  <div class="header-card">
    <h2><i class="fas fa-hands-helping"></i> Indicação</h2>
    <p class="text-muted">Compartilhe seu cupom de indicação e acompanhe quem o utilizou.</p>
  </div>

  <div class="referral-box">
    <div class="referral-info">
      <div>
        <p class="text-muted">Seu código de indicação</p>
        <strong class="referral-code">{codigoIndicacao}</strong>
      </div>
      <div class="botoes-indicacao">
        <a class="btn-primary btn-wa-indicacao" target="_blank" rel="noopener"
           href={`https://wa.me/?text=${encodeURIComponent(`Estou usando o Hora na Mão para os meus clientes marcarem horário sozinhos pelo link. Crie a sua agenda em https://horanamao.com.br e, no painel, em Meus créditos > "Possui um cupom?", use o código ${codigoIndicacao} para ganhar ${diasAmigo} dias grátis.`)}`}>
          <i class="fab fa-whatsapp"></i> Enviar no WhatsApp
        </a>
        <button class="btn-primary" on:click={copiarCodigo} disabled={!codigoIndicacao}>
          <i class="fas fa-copy"></i> Copiar código
        </button>
      </div>
    </div>

    <div class="referral-texto">
      <p>Compartilhe este código com amigos: quem usar recebe <strong>{diasAmigo} dias</strong> de crédito e você, que indicou, ganha <strong>{diasIndicador} dias</strong> automaticamente.</p>
    </div>

    {#if mensagem}
      <div class="msg-retorno sucesso"><i class="fas fa-check-circle"></i> {mensagem}</div>
    {/if}
  </div>

  <div class="history-card">
    <div class="header-card">
      <h3><i class="fas fa-history text-muted"></i> Histórico de indicações</h3>
    </div>

    <div class="table-responsive">
      <table class="tabela-indicacoes">
        <thead>
          <tr>
            <th>Data</th>
            <th>Amigo</th>
            <th>Dias (amigo)</th>
            <th>Dias (você)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {#if carregando}
            <tr><td colspan="5" class="text-center py-4"><i class="fas fa-spinner fa-spin text-muted"></i> Carregando histórico...</td></tr>
          {:else if historico.length === 0}
            <tr><td colspan="5" class="text-center py-4 text-muted">Nenhuma indicação utilizada ainda.</td></tr>
          {:else}
            {#each historico as item}
              <tr>
                <td>{formatarData(item.criado_em)}</td>
                <td>{item.amigo_nome || item.amigo_email || '—'}</td>
                <td>+{diasAmigo} dias</td>
                <td>+{diasIndicador} dias</td>
                <td class="status-cell {item.status}">{item.status === 'usado' ? 'Aprovado' : item.status === 'em_pagamento' ? 'Em pagamento' : 'Pendente'}</td>
              </tr>
            {/each}
          {/if}
        </tbody>
      </table>
    </div>
  </div>
</div>

<style>
  .referral-box, .history-card {
    background: white;
    border-radius: 16px;
    padding: 28px;
    border: 1px solid #e0e6e2;
    box-shadow: 0 4px 18px rgba(0,0,0,0.04);
    margin-top: 24px;
  }

  .referral-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    flex-wrap: wrap;
  }

  .referral-code {
    display: inline-block;
    background: #f1f7f1;
    padding: 14px 18px;
    border-radius: 12px;
    font-size: 1.05rem;
    letter-spacing: 0.2em;
    margin-top: 8px;
  }

  .referral-texto {
    margin-top: 18px;
    color: #5a7063;
    line-height: 1.68;
  }

  .btn-primary {
    background: #4a6c56;
    color: white;
    border: none;
    padding: 14px 22px;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .btn-primary:hover:not(:disabled) {
    background: #3a5443;
  }

  .btn-primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .tabela-indicacoes {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    margin-top: 16px;
  }

  .tabela-indicacoes th,
  .tabela-indicacoes td {
    padding: 14px 16px;
    border-bottom: 1px solid #e9f0ed;
    font-size: 0.94rem;
    color: #2c3e34;
  }

  .tabela-indicacoes th {
    background: #f8faf9;
    color: #5a7063;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.78rem;
    letter-spacing: 0.05em;
  }

  .status-cell {
    text-transform: capitalize;
    font-weight: 700;
    padding: 9px 12px;
    display: inline-flex;
    border-radius: 999px;
  }

  .status-cell.usado { background: #eef5f0; color: #2f855a; }
  .status-cell.em_pagamento { background: #fefcbf; color: #975a16; }
  .status-cell.pendente { background: #ebf4ff; color: #2b6cb0; }

  .msg-retorno {
    margin-top: 16px;
    padding: 14px 18px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
  }

  .msg-retorno.sucesso {
    background: #eef5f0;
    color: #2f855a;
    border: 1px solid #c6f6d5;
  }

  @media (max-width: 760px) {
    .referral-info {
      flex-direction: column;
      align-items: stretch;
    }

    .referral-code {
      width: 100%;
      text-align: center;
    }

    .btn-primary {
      width: 100%;
    }
  }
  .botoes-indicacao { display: flex; gap: 8px; flex-wrap: wrap; }
  .btn-wa-indicacao { background: #25d366 !important; text-decoration: none; display: inline-flex; align-items: center; gap: 6px; }
</style>
